module.exports = __webpack_public_path__ + "images/winston-ling@2x.bea804bea8eb4b6280540e1e15027397.jpeg";


//////////////////
// WEBPACK FOOTER
// ../src/client/assets/images/team/winston-ling@2x.jpeg
// module id = 1035
// module chunks = 0